<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <el-tabs v-model="activeName" class="content-main" >
        <el-tab-pane label="系统功能" name="first">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(item,index) in soft" :key="index" class="item">
              <el-card :body-style="{ padding: '0px' }">
                <img  :src="item.icon"  class="image">
                <div style="padding: 14px;">
                  <div class="title">{{item.title}}</div>
                  <div class="desction">{{item.description}}</div>
                  <!-- <div>
                    <span class="price">￥:{{item.fee}}</span>
                    <el-button type="text" class="button">立即购买</el-button>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="系统硬件" name="second">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(item,index) in hardware" :key="index" class="item">
              <el-card :body-style="{ padding: '0px' }">
                <img  :src="item.icon"  class="image">
                <div style="padding: 14px;">
                  <div class="title">{{item.title}}</div>
                  <div class="desction">{{item.description}}</div>
                  <!-- <div>
                    <span class="price">￥:{{item.fee}}</span>
                    <el-button type="text" class="button">立即购买</el-button>
                  </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="短信" name="third">
          <el-row :gutter="20" >
            <el-col :span="6" v-for="(item,index) in sms" :key="index" class="item">
              <el-card :body-style="{ padding: '0px' }">
                <img  :src="item.icon"  class="image">
                <div style="padding: 14px;">
                  <div class="title">{{item.title}}</div>
                  <div class="desction">{{item.description}}</div>
                  <div>
                    <span class="price">￥:{{item.fee}}</span>
                    <el-button type="text" class="button">立即购买</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane> -->
      </el-tabs>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {      
        activeName:'first',
        loading:true,
        soft:[],
        hardware:[],
        sms:[]
      }
    },
    computed:{
    },
    mounted(){
      this.GetDate();
    },
    components:{ 
    },
    methods:{  
      GetDate:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/System/FeaturePackMall',          
        }).then(function (resp) {
          that.soft = resp.data.soft
          that.hardware = resp.data.hardware
          that.sms = resp.data.sms
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    created(){    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-main
  padding 24px
.item
  padding-top 20px
.image
  width 100%
.title
  font-size 16px
  font-weight: 500
  color rgba(0, 0, 0, 0.85)
.desction
  height 50px
  margin-top 5px
  color rgba(0, 0, 0, 0.45)
.price
  height 40px
  line-height 40px
.button
  float right
</style>